import { get_platform_name, get_page_vm, is_debug } from './pageInfo'
import type { App } from 'vue'
import Stat from './stat'
import Report from './report'
import { getUniAppEnv } from '@/utils/env'
import { copy, pyToast } from '@/utils/util'

const stat = Stat.getInstance()
const report = new Report()
// 用于判断是隐藏页面还是卸载页面
let isHide = false

const lifecycle = {
  onLaunch (options) {
    // 进入应用上报数据
    stat.launch(options, this)
    // 上报push推送id
    // stat.pushEvent(options)
  },
  onLoad (options) {
    stat.load(options, this)
    // TODO: 重写分享，获取分享上报事件
    // if (this.$scope && this.$scope.onShareAppMessage) {
    //   let oldShareAppMessage = this.$scope.onShareAppMessage
    //   this.$scope.onShareAppMessage = function (options) {
    //     stat.interceptShare(false)
    //     return oldShareAppMessage.call(this, options)
    //   }
    // }
  },
  onShow () {
    isHide = false
    stat.show(this)
  },
  onHide () {
    isHide = true
    stat.hide(this)
  },
  onUnload () {
    if (isHide) {
      isHide = false
      return
    }
    stat.hide(this)
  },
  onError (e) {
    try {
      console.log("===============应用上报错误-onError============", e)
      if (getUniAppEnv().env !== 'prod') {
        uni.showModal({
          title: '-onError-',
          content: `${e}\ntoString: ${e.toString()}`,
          success: function (res) {
            if (res.confirm) {
              copy(`${e}\ntoString: ${e.toString()}`)
            }
          }
        });
      }
      /**
      * kibaba上请求错误参考日志（http://kibana.pengyin.vip/app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1M,to:now))&_a=(columns:!(em,env,v,lt_text),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'41a09050-5f44-11ed-95f4-57541550074e',key:lt,negate:!f,params:(query:'31'),type:phrase),query:(match_phrase:(lt:'31'))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'41a09050-5f44-11ed-95f4-57541550074e',key:em,negate:!f,params:(query:statusCode),type:phrase),query:(match_phrase:(em:statusCode)))),index:'41a09050-5f44-11ed-95f4-57541550074e',interval:auto,query:(language:lucene,query:''),sort:!())）
      * {"data":{"code":10004,"data":null,"error":"暂无此藏品信息"},"statusCode":200,"header":{"access-control-allow-headers":"Authorization, Content-Length, X-CSRF-Token, Token,session,X_Requested_With,Accept, Origin, Host, Connection, Accept-Encoding, Accept-Language,DNT, X-CustomHeader, Keep-Alive, User-Agent, X-Requested-With, If-Modified-Since, Cache-Control, Content-Type, Pragma","access-control-allow-origin":"*","content-length":"58","content-type":"application/json; charset=utf-8"},"cookies":[],"errMsg":"request:ok"} 
      */
      if (e.response && (e.response.data.code || e.response.data.code === 0) || e.indexOf('statusCode') > -1) {
        // 接口请求不上报
      } else {
        stat.error(e)
      }
    } catch (error) {

    }

  }
}

// 加载统计代码
function load_stat2 () {
  // #ifdef VUE3
  // uni.onCreateVueApp((app) => {
  // app.mixin(lifecycle)
  // uni.report = function (type, options) {
  //   console.log("uni.report", type, options)
  //   stat.sendEvent(type, options)
  // }
  // })
  console.log('get_platform_name', get_platform_name())
  if (get_platform_name() !== 'h5' && get_platform_name() !== 'n') {
    uni.onAppHide(() => {
      stat.appHide(get_page_vm())
    })
    uni.onAppShow(() => {
      stat.appShow(get_page_vm())
    })
  }
  // #endif
}

function load_stat (app) {
  try {
    app.mixin(lifecycle)
    // app.provide('$pyStat', report)
    app.provide('$pyStat', stat)
  } catch (error) {

  }
}

function main (app: App<Element>) {
  try {
    load_stat(app)
  } catch (error) {

  }
  app.config.errorHandler = (err: any, instance: any, info: any) => {
    /**
     * err：错误对象、发生错误的组件实例
     * instance：vue实例
     * info: 是一个 Vue 特定的错误信息  例如：错误是在哪个生命周期的钩子上抛出的
     */
    // 处理错误，例如：报告给一个服务
    if (getUniAppEnv().env !== 'prod') {
      console.error(`Error: ${err.toString()}\nInfo: ${info}`)
      uni.showModal({
        title: '-Error-',
        content: `${err.toString()}\nInfo: ${info}`,
        success: function (res) {
          if (res.confirm) {
            copy(`${err.toString()}\nInfo: ${info}`)
          }
        }
      });
    }
    try {
      /**
      * kibaba上请求错误参考日志（http://kibana.pengyin.vip/app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1M,to:now))&_a=(columns:!(em,env,v,lt_text),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'41a09050-5f44-11ed-95f4-57541550074e',key:lt,negate:!f,params:(query:'31'),type:phrase),query:(match_phrase:(lt:'31'))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'41a09050-5f44-11ed-95f4-57541550074e',key:em,negate:!f,params:(query:statusCode),type:phrase),query:(match_phrase:(em:statusCode)))),index:'41a09050-5f44-11ed-95f4-57541550074e',interval:auto,query:(language:lucene,query:''),sort:!())）
      * {"data":{"code":10004,"data":null,"error":"暂无此藏品信息"},"statusCode":200,"header":{"access-control-allow-headers":"Authorization, Content-Length, X-CSRF-Token, Token,session,X_Requested_With,Accept, Origin, Host, Connection, Accept-Encoding, Accept-Language,DNT, X-CustomHeader, Keep-Alive, User-Agent, X-Requested-With, If-Modified-Since, Cache-Control, Content-Type, Pragma","access-control-allow-origin":"*","content-length":"58","content-type":"application/json; charset=utf-8"},"cookies":[],"errMsg":"request:ok"} 
      */
      if (err.isAxiosError || (err.response && (err.response.data.code || err.response.data.code === 0)) || err.indexOf('statusCode') > -1) {
        // 接口请求不上报
      } else {
        report.throw(err)
      }
    } catch (error) { }
  }
  // if (is_debug) {
  //   console.log('=== uni统计开启,version:2.0 ===')
  //   load_stat()
  // } else {
  //   if (process.env.NODE_ENV === 'development') {
  //     uni.report = function (type, options) { }
  //   } else {
  //     load_stat()
  //   }
  // }
}
export function setupGlobalStat (app: App<Element>) {
  main(app)
}
